import React from "react";
import styled from "styled-components";

import { LOGO_HORIZONTAL } from '../../images';
import { INTRODUCE, INTRODUCE_MOBILE, HISTORY, BREAK_POINTS } from '../../constants';

const OuterWrapper = styled.div``;

const Wrapper = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    padding: 0 24px;
  }
`;

const IntroduceWrapper = styled.section`
  margin: 0 auto;
  padding: 60px 0 126px 0;
  word-break: keep-all;
  white-space: pre-line;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: -0.5px;
  text-align: center;
  color: #969696;

  img {
    margin: 60px 0;
    width: 320px;
    height: 94px;
  }

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    padding: 48px 0 100px 0;
    font-size: 14px;

    img {
      margin: 48px 0;
      width: 280px;
      height: 82px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    padding: 32px 0 60px 0;
    font-size: 12px;

    img {
      margin: 32px 0;
      width: 240px;
      height: 70px;
    }
  }
`;

const HistoryWrapper = styled.section`
  background-color: #fafafa;
  padding: 120px 0 106px;
  
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-bottom: 60px;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: -0.38px;
    text-align: center;
    color: #969696;
  }

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    padding: 100px 0 80px;

    h2 {
      margin-bottom: 48px;
      font-size: 18px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    padding: 60px 24px;

    h2 {
      margin-bottom: 32px;
      font-size: 16px;
    }
  }
`;

const YearSection = styled.div`
  width: 618px;
  display: flex;
  margin-bottom: 40px;
  position: relative;

  // 세로선
  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 0;
    width: 1px;
    height: calc(100% + 56px);
    background-color: #949cca;
  }

  &:first-of-type::before {
    top: 10px;
  }

  &:last-of-type::before {
    top: -50px;
  }

  h3 {
    flex: 0 0 80px;
    position: relative;
    padding-top: 2px;
    padding-left: 23px;

    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: -0.38px;
    color: #7172a5;

    // 점
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 7px;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: #949cca;
      z-index: 1;
    }
  }

  .events {
    flex: 1;
    padding-left: 20px;
  }

  &:last-child::before {
    height: 100%;
  }

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 520px;  // 타블렛에서 너비 축소
    margin-bottom: 32px;

    h3 {
      flex: 0 0 70px;
      font-size: 18px;
      padding-left: 20px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: 100%;
    margin-bottom: 24px;
    flex-direction: column;

    h3 {
      flex: 0 0 30px;
      font-size: 14px;
      padding-left: 20px;

      &::before {
        left: 1px;
        width: 7px;
        height: 7px;
      }
    }

    // 세로선 길이 조정
    &::before {
      content: '';
      position: absolute;
      left: 4px;
      top: 0;
      width: 1px;
      height: calc(100% + 32px);
      background-color: #949cca;
    }

    &:first-of-type::before {
      top: 8px;
    }

    &:last-of-type::before {
      height: calc(100% - 16px);
    }
  }
`;

const Event = styled.div`
  display: flex;
  
  .date {
    flex: 0 0 30px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.88;
    letter-spacing: -0.5px;
    color: #949cca;
  }

  .text {
    flex: 1;
    padding-left: 77px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.88;
    letter-spacing: -0.5px;
    color: #505050;
  }


  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    .date {
      font-size: 14px;
    }

    .text {
      padding-left: 60px;
      font-size: 14px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    .date {
      font-size: 10px;
    }

    .text {
      padding-left: 40px;
      font-size: 10px;
    }
  }
`;

const Title = styled.h2`
  margin: 16px 0 30px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.38px;
  text-align: center;
  color: #969696;
`;

function HistoryPresenter() {
  return (
    <OuterWrapper> 
      <Wrapper>
        <Introduce />
      </Wrapper>
      <History />
    </OuterWrapper>
  );
};

const Introduce = () => {
  return (
    <IntroduceWrapper>
      {( window.innerWidth <= BREAK_POINTS.TABLET ) && ( <Title>COMPANY</Title> )}
      
      <div>
        <img src={LOGO_HORIZONTAL} alt="logo" />
      </div>
      {( window.innerWidth < BREAK_POINTS.TABLET ) ? INTRODUCE_MOBILE : INTRODUCE}
    </IntroduceWrapper>
  );
};

const History = () => {
  return (
    <HistoryWrapper>
      <h2>HISTORY</h2>
      {HISTORY.map(({ year, events }) => (
        <YearSection key={year}>
          <h3>{year}</h3>
          <div className="events">
            {events.map(({ date, text }) => (
              <Event key={date}>
                <div className="date">{date}</div>
                <div className="text">{text}</div>
              </Event>
            ))}
          </div>
        </YearSection>
      ))}
    </HistoryWrapper>
  );
};

export default HistoryPresenter;
